// Logo component for Bohol Cacao Industry Information System
import React, { useState } from 'react';

export const Logo = ({ 
  className = "", 
  alt = "Bohol Cacao Industry Information System Logo",
  showText = true,
  size = "medium" 
}) => {
  const [imageError, setImageError] = useState(false);
  
  const sizeClasses = {
    small: "h-8 w-8",
    medium: "h-10 w-10", 
    large: "h-16 w-16"
  };
  
  const textSizes = {
    small: "text-sm",
    medium: "text-base",
    large: "text-xl"
  };

  // Fallback component if image fails to load
  const Fallback = () => (
    <div 
      className={`flex items-center justify-center bg-amber-900 text-white rounded-full ${sizeClasses[size]} ${className}`}
    >
      <span className={`font-bold ${textSizes[size]}`}>BC</span>
    </div>
  );

  return (
    <div className="flex items-center space-x-2">
      {!imageError ? (
        <img
          src="/bohol-cacao-logo.png" 
          loading='lazy'
          alt={alt}
          className={`rounded-full object-cover ${sizeClasses[size]} ${className}`}
          onError={() => setImageError(true)}
          onLoad={() => setImageError(false)}
        />
      ) : (
        <Fallback />
      )}
      {showText && (
        <span className={`font-semibold text-white ${textSizes[size]}`}>
          Bohol Cacao Industry Information System
        </span>
      )}
    </div>
  );
};

// Keep backward compatibility
export const LogoPlaceholder = Logo;
export default Logo;
